import { createColumnHelper, FilterFn, Row } from '@tanstack/react-table';
import { TerminalContainer } from 'modules/global/adapters/crpAPI';
import DataGrid from 'modules/global/components/DataGrid';
import i18n from 'modules/global/config/i18n';

const arrayFilter: FilterFn<TerminalContainer> = (
  row: Row<TerminalContainer>,
  columnId: string,
  filterValue: string
) => {
  const values: string[] = row.getValue(columnId);

  return values.some((value) => value.toLowerCase().includes(filterValue.toLowerCase()));
};

const columnHelper = createColumnHelper<TerminalContainer>();

const baseReleasePartyColumns = [
  columnHelper.accessor('equipmentNumber', {
    cell: (info) => info.getValue(),
    size: 250,
    header: () => i18n.t('glossary:containerNumber'),
    filterFn: 'includesString',
  }),
  columnHelper.accessor('billOfLadingNumbers', {
    cell: (info) => info.getValue()?.join(', '),
    header: () => i18n.t('glossary:billOfLadingNumbers'),
    filterFn: arrayFilter,
  }),
  columnHelper.accessor('terminalName', {
    cell: (info) => info.getValue(),
    header: () => i18n.t('glossary:terminalName'),
    filterFn: 'includesString',
  }),
  columnHelper.accessor('receivedFromName', {
    cell: (info) => info.getValue(),
    header: () => i18n.t('glossary:receivedFrom'),
    filterFn: 'includesString',
  }),
  columnHelper.accessor('receivedFromNxtEntityId', {
    cell: (info) => info.getValue(),
    header: () => i18n.t('glossary:receivedFromNxtEntityId'),
    filterFn: 'includesString',
  }),
  columnHelper.accessor('imoNumber', {
    cell: (info) => info.getValue(),
    header: () => i18n.t('glossary:imoNumber'),
    filterFn: 'includesString',
  }),
  columnHelper.accessor('stayNumber', {
    cell: (info) => info.getValue(),
    header: () => i18n.t('glossary:stayNumber'),
    filterFn: 'includesString',
  }),
];

const baseReleasePartyColumnsWithCheckbox = [
  columnHelper.display({
    id: 'actions',
    cell: (cellProps) => <DataGrid.CheckboxRow {...cellProps} />,
    header: (headerProps) => <DataGrid.CheckboxHeader {...headerProps} />,
    size: 60,
    enableResizing: false,
  }),
  ...baseReleasePartyColumns,
];

export const releasePartyColumns = [...baseReleasePartyColumnsWithCheckbox];
